import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { addEvent, getHandler as _getHandler, removeEvent } from './utils';
import { getTouchY, handleScroll } from './handleScroll';
import { EVENTS } from './defaultEvents';
import { isInside, isInsideCurrent, isLastInGroup, shouldIgnoreEvent } from './isInside';
var groupTracker = {};
var EventLock = /*#__PURE__*/
function (_Component) {
  _inheritsLoose(EventLock, _Component);
  function EventLock() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setRef", function (ref) {
      _this.ref = ref;
      if (ref) {
        if (!('scrollTop' in ref)) {
          // eslint-disable-next-line
          console.error('Locky: would not work for ', ref);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollWheel", function (event) {
      return handleScroll(_this.ref, event, event.deltaY, _this.props.preventOnly);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTouchStart", function (event) {
      _this.touchStart = getTouchY(event);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTouchMove", function (event) {
      return handleScroll(_this.ref, event, _this.touchStart - getTouchY(event), _this.props.preventOnly);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isEventInLock", function (event) {
      return _this.ref && isInside(_this.ref, event.target);
    });
    return _this;
  }
  var _proto = EventLock.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props$group = this.props.group,
      group = _this$props$group === void 0 ? '' : _this$props$group;
    if (!groupTracker[group]) {
      groupTracker[group] = [];
    }
    groupTracker[group].unshift(this);
    if (this.props.headless) {
      // eslint-disable-next-line
      this.setRef(ReactDOM.findDOMNode(this));
    }
    if (this.props.enabled) {
      this.enable();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this2 = this;
    if (this.props.enabled) {
      this.disable();
    }
    var group = this.props.group;
    if (group) {
      groupTracker[group] = groupTracker[group].filter(function (x) {
        return x !== _this2;
      });
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(oldProps) {
    if (oldProps.enabled !== this.props.enabled) {
      if (this.props.enabled) {
        this.enable();
      } else {
        this.disable();
      }
    }
  };
  _proto.enable = function enable() {
    var _this3 = this;
    var handlers = this.getEventHandlers();
    this.documentEvents = Object.keys(handlers).map(function (event) {
      return addEvent(document, event, _this3.getHandler(event, handlers[event]), true);
    }).filter(function (x) {
      return x;
    });
    this.nodeEvents = [];
    if (handlers.scroll) {
      var _this$nodeEvents;
      (_this$nodeEvents = this.nodeEvents).push.apply(_this$nodeEvents, [addEvent(this.ref, 'wheel', this.scrollWheel, true), addEvent(this.ref, 'touchstart', this.scrollTouchStart, true), addEvent(this.ref, 'touchmove', this.scrollTouchMove, true)]);
    }
  };
  _proto.disable = function disable() {
    this.documentEvents.forEach(removeEvent);
    this.nodeEvents.forEach(removeEvent);
  };
  _proto.getEventHandlers = function getEventHandlers() {
    var _this$props = this.props,
      noDefault = _this$props.noDefault,
      events = _this$props.events;
    return Object.assign({}, noDefault ? {} : EVENTS, events || {});
  };
  _proto.getHandler = function getHandler(eventName, option) {
    var _this4 = this;
    var handler = _getHandler(eventName, option, this.props.onEscape);
    if (handler) {
      return function (event) {
        if (shouldIgnoreEvent(event.target)) {
          return;
        }
        var _this4$props = _this4.props,
          leaded = _this4$props.leaded,
          _this4$props$group = _this4$props.group,
          group = _this4$props$group === void 0 ? '' : _this4$props$group;
        if (!isInsideCurrent(_this4.ref, event.target)) {
          if (leaded && group && (isLastInGroup(_this4.ref) || groupTracker[group][0] === _this4) || !_this4.isEventInLock(event)) {
            handler(event);
          }
        }
      };
    }
    return null;
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      component = _this$props2.component,
      group = _this$props2.group,
      className = _this$props2.className;
    var Node = component || React.createElement("div", null).type;
    return this.props.headless ? this.props.children : React.createElement(Node, {
      ref: this.setRef,
      "data-locky-group": group,
      className: className
    }, this.props.children);
  };
  return EventLock;
}(Component);
_defineProperty(EventLock, "defaultProps", {
  enabled: true,
  preventOnly: false
});
export var LockyTransparent = function LockyTransparent(_ref) {
  var children = _ref.children,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  return React.createElement("div", {
    "data-locky-transparent": enabled
  }, children);
};
LockyTransparent.defaultProps = {
  enabled: true
};
export default EventLock;